import { JBGShopify } from '$services/shopify'

export default defineNuxtPlugin(({ $i18n, $listrak }) => {
    const runtimeConfig = useRuntimeConfig()
    const shopifyProvider = new JBGShopify(<JBGShopify.InitOptions>{
        ...runtimeConfig.public.shopify,
        locale: $i18n.locale.value,
        countryCode: useCookie('cloudfront-viewer-country')?.value || 'US',
        listrak: $listrak.ltk
    })

    return {
        provide: {
            shopify: shopifyProvider
        }
    }
})
